module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/91e790e3f484472cb898d148c61c3349.png";